module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjNGFhNmRiIiBkPSJtMTAuNiAxNS41MDhsNi4zOTYtNi4zOTZsLS43MDctLjcwOGwtNS42ODkgNS42ODhsLTIuODUtMi44NWwtLjcwOC43MDh6TTUuNjE2IDIwcS0uNjkxIDAtMS4xNTMtLjQ2MlQ0IDE4LjM4NFY1LjYxNnEwLS42OTEuNDYzLTEuMTUzVDUuNjE2IDRoMTIuNzY5cS42OSAwIDEuMTUzLjQ2M1QyMCA1LjYxNnYxMi43NjlxMCAuNjktLjQ2MiAxLjE1M1QxOC4zODQgMjB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MaterialSymbolsLightCheckBox.svg
// module id = 1096
// module chunks = 21